import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TeamTopMenu from 'team/components/home/TeamTopMenu';
import TeamProgressUI from 'team/shared/features/progress/TeamProgressUI';

const TeamHomeContainer = () => {
    const navigate = useNavigate();

    const handleAddMembersClick = (option) => {
        console.log('Add member option selected:', option);
        // Navigate to the add member container with the selected option
        navigate(`/team/add-members?option=${option}`);
    };

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            backgroundColor: '#f8f9fa',
            width: '100%',
            maxWidth: '100vw',
            overflow: 'hidden'
        }}>
            {/* Top Menu */}
            <TeamTopMenu onAddMembersClick={handleAddMembersClick} />

            {/* Main Content */}
            <Box sx={{
                flex: 1,
                padding: '8px 16px 24px 16px',
                overflow: 'visible'
            }}>
                <TeamProgressUI />
            </Box>
        </Box>
    );
};

export default TeamHomeContainer;
